'use client';

import * as DS from '@aurorasolar/ds';
import { x } from '@xstyled/styled-components';

import { titleCase } from '../data';
import { LiveStats, metersToFeet } from '../engine';

type Props = {
  bestDistance: number;
  highScore: number;
  stats: LiveStats;
};

const fmt = (value: number, digits = 1): string =>
  value.toLocaleString('en-US', { maximumFractionDigits: digits, minimumFractionDigits: digits });

export const Hud = ({ bestDistance, highScore, stats }: Props) => (
  <DS.Card variant="secondary">
    <x.div display="flex" flexDirection="column" gap={3} p={4}>
      <x.div alignItems="center" display="flex" gap={3} justifyContent="space-between">
        <DS.Chip size="sm">
          <x.span alignItems="center" display="inline-flex" gap={1}>
            <DS.IconSunFill size={4} />
            Level {stats.level.index} · {titleCase(stats.level.title)}
          </x.span>
        </DS.Chip>
        <DS.Status
          bg="uiStatus.pending"
          color="white"
          icon={DS.IconLightningFill}
          size="sm"
          tooltip={{ children: 'Current array output in these sky conditions' }}
        />
      </x.div>

      <DS.StatisticGroup aria-label="Live solar generation">
        <x.div display="grid" gap={4} gridTemplateColumns={{ _: '1fr 1fr', md: 'repeat(4, 1fr)' }}>
          <DS.Statistic label="Energy generated" size="md" unit="kWh" value={fmt(stats.energyKwh)} />
          <DS.Statistic label="Distance" size="md" unit="ft" value={fmt(metersToFeet(stats.distanceM), 0)} />
          <DS.Statistic label="Best energy" size="md" unit="kWh" value={fmt(highScore)} />
          <DS.Statistic label="Best distance" size="md" unit="ft" value={fmt(metersToFeet(bestDistance), 0)} />
        </x.div>
      </DS.StatisticGroup>

      <DS.Text as="p" color="uiBodyCopy" text="body14">
        {stats.level.concept}: {stats.level.blurb}
      </DS.Text>
    </x.div>
  </DS.Card>
);
